/* MAIN */
var FileType;
(function (FileType) {
    FileType[FileType["DIR"] = 1] = "DIR";
    FileType[FileType["FILE"] = 2] = "FILE";
})(FileType || (FileType = {}));
var FSTargetEvent;
(function (FSTargetEvent) {
    FSTargetEvent["CHANGE"] = "change";
    FSTargetEvent["RENAME"] = "rename";
})(FSTargetEvent || (FSTargetEvent = {}));
var FSWatcherEvent;
(function (FSWatcherEvent) {
    FSWatcherEvent["CHANGE"] = "change";
    FSWatcherEvent["ERROR"] = "error";
})(FSWatcherEvent || (FSWatcherEvent = {}));
var TargetEvent;
(function (TargetEvent) {
    TargetEvent["ADD"] = "add";
    TargetEvent["ADD_DIR"] = "addDir";
    TargetEvent["CHANGE"] = "change";
    TargetEvent["RENAME"] = "rename";
    TargetEvent["RENAME_DIR"] = "renameDir";
    TargetEvent["UNLINK"] = "unlink";
    TargetEvent["UNLINK_DIR"] = "unlinkDir";
})(TargetEvent || (TargetEvent = {}));
var WatcherEvent;
(function (WatcherEvent) {
    WatcherEvent["ALL"] = "all";
    WatcherEvent["CLOSE"] = "close";
    WatcherEvent["ERROR"] = "error";
    WatcherEvent["READY"] = "ready";
})(WatcherEvent || (WatcherEvent = {}));
/* EXPORT */
export { FileType, FSTargetEvent, FSWatcherEvent, TargetEvent, WatcherEvent };
